module.exports = __webpack_public_path__ + "fonts/Arimo-700-greek28.98bbdf8.woff2";